export const messages_en = {
  error_default: "Something went wrong. :(",
  username_taken: "Username is already taken",
  email_taken: "Email is already taken",
  passwords_not_matching: "Passwords do not match. ",
  password_too_short: "Password needs to be at least {0} characters long. ",
  password_needs_digit: "Password needs to include at least one digit. ",
  password_needs_uppercased:
    "Password needs to include at least one uppercased letter. ",
  password_needs_lowercased:
    "Password needs to include at least one lowercased letter. ",
  password_not_allowed_special:
    "Password must not contain any special characters. ",
  registration_succes: "You have sucessfully registered!",
  serverError:
    "An error occurred during the communication with the server! Please try again or contact the system administrator.",
  delete_selected_confirm_message:
    "Are you sure you want to delete selected items?",
  documentsDeleteSuccess: "Document(s) has been successfully deleted!",
  documentsUploadSuccess: "Document(s) has been successfully uploaded!",
  nothingSelectedMessage:
    "There is no selected item. Please select item you want to delete.",
  changesNotSavedMessage:
    "You have unsaved changes, are you sure you want to leave?",
  reactivate_confirm_message: "Are you sure you want to reactivate item?",
  clientError:
    "An error occurred on the client! Please try again or contact the system administrator.",
  settingsSaveSuccess: "Settings successfully saved!"
};
